import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ticketApi, TicketListParams } from '../services/ticketApi';

export function useTickets(params: TicketListParams) {
  return useQuery({
    queryKey: ['tickets', 'list', params],
    queryFn: () => ticketApi.listTickets(params),
  });
}

export function useTicket(id: string | undefined) {
  return useQuery({
    queryKey: ['tickets', 'detail', id],
    queryFn: () => ticketApi.getTicket(id!),
    enabled: !!id,
  });
}

export function useTicketStats() {
  return useQuery({
    queryKey: ['tickets', 'stats'],
    queryFn: ticketApi.getStats,
    staleTime: 30_000,
  });
}

export function useTicketCategories() {
  return useQuery({
    queryKey: ['tickets', 'categories'],
    queryFn: ticketApi.getCategories,
    staleTime: 5 * 60_000,
  });
}

export function useCreateTicket() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ticketApi.createTicket,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tickets'] });
    },
  });
}

export function useAddComment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ ticketId, data }: { ticketId: string; data: { body: string } }) =>
      ticketApi.addComment(ticketId, data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['tickets', 'detail', variables.ticketId] });
    },
  });
}
